import { storage } from "@/components/Storage";

export const user = {
    exists: function () {
        return !!storage.user;
    },
    save: function (data) {
        storage.user = JSON.stringify(data);
    },
    data: function () {
        return storage.user ?? {};
    },
    set: function (key, value) {
        const data = user.data();
        key = key.split('.');
        key.length === 1 ? data[key] = value : data[key[0]][key[1]] = value;
        user.save(data);
    },
    has: function (key) {
        key = key.split('.');
        const data = user.data();
        if (key.length === 1) {
            return data.hasOwnProperty(key) && data[key];
        } else {
            if (!data.hasOwnProperty(key[0])) {
                return false;
            }
            return data[key[0]].hasOwnProperty(key[1]) && data[key[0]][key[1]];
        }
    },
    get: function (key) {
        if (user.has(key)) {
            key = key.split('.');
            return key.length === 1 ? user.data()[key] : user.data()[key[0]][key[1]];
        }
        return null;
    },
    remove: function (key) {
        const data = user.data();
        key = key.split('.');
        key.length === 1 ? (delete data[key]) : (delete data[key[0]][key[1]]);
        user.save(data);
    },
    destroy: function () {
        delete storage.user;
    }
};
